import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Camera, Droplets, HardHat, Clock, ArrowRight, CheckCircle2, Waves } from 'lucide-react';
const Hero = () => {
  return <div className="relative h-[80vh] min-h-[600px] w-full flex items-center justify-center overflow-hidden" data-id="element-172">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/jcgJZkzKQqhvkknuWyqW7A/testimonials-page-image.jpg')",
      backgroundPosition: 'center center'
    }} data-id="element-173">
        {/* Overlay - Navy Blue tint */}
        <div className="absolute inset-0 bg-[#1e3a5f]/75" data-id="element-174"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto mt-20" data-id="element-175">
        <div className="inline-block bg-[#d4a017] text-[#1e3a5f] px-4 py-1 font-bold text-sm uppercase tracking-widest mb-6 rounded-sm" data-id="element-176">
          50 Years of Experience
        </div>
        <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-bold uppercase tracking-wider mb-6 leading-tight drop-shadow-lg" data-id="element-177">
          East Tennessee's <br data-id="element-178" />
          <span className="text-[#d4a017]" data-id="element-179">Commercial Sewer</span> & Drain Company
        </h1>
        <div className="w-32 h-1 bg-[#d4a017] mx-auto mb-8" data-id="element-180"></div>
        <p className="text-gray-100 text-lg md:text-2xl font-light mb-10 max-w-3xl mx-auto" data-id="element-181">
          Cleaning Service & Repair Company
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-182">
          <Link to="/contact" className="inline-block bg-[#d4a017] hover:bg-[#b88b14] text-[#1e3a5f] text-base font-bold uppercase tracking-wider px-8 py-4 rounded transition-all transform hover:scale-105 shadow-lg" data-id="element-183">
            Request Service
          </Link>
          <Link to="/services" className="inline-block bg-transparent border-2 border-white hover:bg-white hover:text-[#1e3a5f] text-white text-base font-bold uppercase tracking-wider px-8 py-4 rounded transition-all transform hover:scale-105 shadow-lg" data-id="element-184">
            Our Services
          </Link>
        </div>
      </div>
    </div>;
};
const EmergencyBanner = () => {
  return <div className="bg-[#d4a017] py-8 px-4 shadow-lg relative z-20" data-id="element-185">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center md:justify-between text-[#1e3a5f] text-center md:text-left" data-id="element-186">
        <div className="flex items-center mb-4 md:mb-0" data-id="element-187">
          <div className="bg-[#1e3a5f] p-3 rounded-full mr-4" data-id="element-188">
            <Clock className="w-8 h-8 text-[#d4a017]" data-id="element-189" />
          </div>
          <div data-id="element-190">
            <h3 className="text-2xl font-black uppercase tracking-wide" data-id="element-191">
              Emergency Service 24/7
            </h3>
            <p className="font-semibold" data-id="element-192">
              Commercial Sewer & Drain Manhole Cleaning & Repair Services
            </p>
          </div>
        </div>
        <a href="tel:8653130028" className="bg-[#1e3a5f] text-white hover:bg-[#152a45] px-8 py-3 rounded font-bold uppercase tracking-wider transition-colors shadow-md flex items-center" data-id="element-193">
          <Phone className="w-5 h-5 mr-2" data-id="element-194" />
          Call Now
        </a>
      </div>
    </div>;
};
const CertificationsSection = () => {
  const certifications = [{
    name: 'PACP - Pipeline Assessment Certification Program',
    image: 'https://cdn.magicpatterns.com/uploads/e3gmq2BP1jL2eiKDfzZ1An/Badge-PACP.png'
  }, {
    name: 'LACP - Lateral Assessment Certification Program',
    image: 'https://cdn.magicpatterns.com/uploads/hNCCy2K15mUz4yJymjbgMJ/LACP-CERTIFIED.png'
  }, {
    name: 'MACP - Manhole Assessment Certification Program',
    image: 'https://cdn.magicpatterns.com/uploads/mu2YoBgtQ6GHD7rj93TwzT/MACP-CERTIFIED2.png'
  }];
  return <section className="py-16 bg-white border-b border-gray-100" data-id="element-195">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-196">
        <h2 className="text-3xl font-bold text-[#1e3a5f] uppercase tracking-wide mb-4" data-id="element-197">
          NASSCO Certified Professionals
        </h2>
        <div className="w-20 h-1.5 bg-[#d4a017] mx-auto mb-6" data-id="element-198"></div>
        <p className="text-gray-600 max-w-2xl mx-auto mb-12 text-lg" data-id="element-199">
          Our team holds NASSCO certifications for pipeline, lateral, and
          manhole assessment, ensuring industry-standard quality and reporting
          for every project.
        </p>

        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16" data-id="element-200">
          {certifications.map((cert, index) => <div key={index} className="group flex flex-col items-center transition-transform duration-300 hover:scale-105" data-id="element-201">
              <img src={cert.image} alt={cert.name} className="h-24 md:h-28 w-auto object-contain drop-shadow-sm filter hover:brightness-110 transition-all" data-id="element-202" />
            </div>)}
        </div>
      </div>
    </section>;
};
const ServicesSection = () => {
  const services = [{
    title: 'Manhole Rehabilitation',
    description: 'Cost-effective repair of aging or damaged manholes. A cheaper alternative than structure replacement that provides a lasting solution.',
    icon: <HardHat className="w-10 h-10 text-[#d4a017]" data-id="element-203" />
  }, {
    title: 'CCTV Pipeline Inspection',
    description: 'State-of-the-art digital camera technology to inspect pipes, identify blockages, and assess structural integrity without excavation.',
    icon: <Camera className="w-10 h-10 text-[#d4a017]" data-id="element-204" />
  }, {
    title: 'Hydro Excavation',
    description: 'Precise, non-destructive excavation using high-pressure water to safely expose underground utilities and pipelines.',
    icon: <Droplets className="w-10 h-10 text-[#d4a017]" data-id="element-205" />
  }, {
    title: 'Sewer Line Cleaning',
    description: 'Commercial sewer and drain cleaning services to keep your systems running efficiently and prevent costly backups.',
    icon: <Waves className="w-10 h-10 text-[#d4a017]" data-id="element-206" />
  }];
  const rehabBenefits = ['Undisturbed surroundings while rehab in process', 'Creates a water-tight seal from infiltration', 'Repairs and protects from H2S damage', 'Cost savings on sewer treatment', 'Reinforces structural integrity of failing manholes'];
  return <section id="services" className="py-20 bg-white" data-id="element-207">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        {/* Intro Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-209">
          <div data-id="element-210">
            <h2 className="text-4xl font-bold text-[#1e3a5f] mb-6" data-id="element-211">
              East Tennessee's Trusted <br data-id="element-212" />
              <span className="text-[#d4a017]" data-id="element-213">Pipe & Drain Experts</span>
            </h2>
            <div className="w-20 h-1.5 bg-[#d4a017] mb-8" data-id="element-214"></div>
            <p className="text-gray-600 text-lg leading-relaxed mb-6" data-id="element-215">
              M&M Pipe Services LLC brings over 50 years of experience to every
              job. We specialize in commercial sewer and drain cleaning,
              offering cutting-edge solutions like digital CCTV inspections and
              hydro excavation.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-216">
              Based in Clinton, TN, we serve the entire East Tennessee region
              with reliable, professional, and 24/7 emergency services. Our team
              is equipped to handle complex municipal and private market
              projects with precision and care.
            </p>
            <Link to="/services" className="text-[#1e3a5f] font-bold uppercase tracking-wide flex items-center hover:text-[#d4a017] transition-colors" data-id="element-217">
              Learn More About Us <ArrowRight className="ml-2 w-5 h-5" data-id="element-218" />
            </Link>
          </div>
          <div className="relative" data-id="element-219">
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#d4a017] opacity-20 rounded-tl-3xl" data-id="element-220"></div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#1e3a5f] opacity-20 rounded-br-3xl" data-id="element-221"></div>
            <img src="https://cdn.magicpatterns.com/uploads/2P99SEz5GrEbouNu8UaELT/missionimage.jpg" alt="M&M Pipe Services team at work" className="rounded-lg shadow-2xl w-full object-cover h-[450px]" data-id="element-222" />
          </div>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20" data-id="element-223">
          {services.map((service, index) => <div key={index} className="bg-gray-50 p-8 rounded-lg border-b-4 border-[#d4a017] hover:-translate-y-2 transition-transform duration-300 shadow-sm hover:shadow-md group" data-id="element-224">
              <div className="bg-white p-4 rounded-full w-20 h-20 flex items-center justify-center mb-6 shadow-sm group-hover:bg-[#1e3a5f] transition-colors duration-300" data-id="element-225">
                <div className="group-hover:text-white transition-colors duration-300" data-id="element-226">
                  {service.icon}
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a5f] mb-3" data-id="element-227">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-228">
                {service.description}
              </p>
            </div>)}
        </div>

        {/* Featured Service: Manhole Rehabilitation */}
        <div className="bg-[#1e3a5f] rounded-2xl overflow-hidden shadow-2xl" data-id="element-229">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-230">
            {/* Content */}
            <div className="p-10 lg:p-14" data-id="element-231">
              <div className="inline-block bg-[#d4a017] text-[#1e3a5f] px-3 py-1 text-xs font-bold uppercase tracking-wider rounded mb-6" data-id="element-232">
                Featured Service
              </div>
              <h3 className="text-3xl lg:text-4xl font-bold text-white mb-6" data-id="element-233">
                Manhole Rehabilitation
              </h3>
              <p className="text-gray-300 text-lg leading-relaxed mb-8" data-id="element-234">
                Manhole rehabilitation is a cost-effective solution for the
                repair of aging or damaged manholes. This innovative application
                is a much cheaper alternative than structure replacement and
                provides a lasting solution.
              </p>

              <h4 className="text-[#d4a017] font-bold uppercase tracking-wide mb-4" data-id="element-235">
                Why Choose Manhole Rehab?
              </h4>
              <ul className="space-y-3 mb-8" data-id="element-236">
                {rehabBenefits.map((benefit, index) => <li key={index} className="flex items-start text-gray-300" data-id="element-237">
                    <CheckCircle2 className="w-5 h-5 text-[#d4a017] mr-3 flex-shrink-0 mt-0.5" data-id="element-238" />
                    <span data-id="element-239">{benefit}</span>
                  </li>)}
              </ul>

              <Link to="/contact" className="inline-flex items-center bg-[#d4a017] hover:bg-[#b88b14] text-[#1e3a5f] font-bold uppercase tracking-wide px-6 py-3 rounded transition-colors" data-id="element-240">
                <Phone className="w-5 h-5 mr-2" data-id="element-241" />
                Get a Quote
              </Link>
            </div>

            {/* Before/After Images */}
            <div className="grid grid-cols-2 h-full min-h-[400px]" data-id="element-242">
              <div className="relative" data-id="element-243">
                <img src="https://cdn.magicpatterns.com/uploads/1C2NBu3NsJVBKxWppqsWSH/pipesvcbefore.jpg" alt="Manhole before rehabilitation" className="w-full h-full object-cover" data-id="element-244" />
                <div className="absolute bottom-0 left-0 right-0 bg-black/70 text-white text-center py-2 font-bold uppercase tracking-wider text-sm" data-id="element-245">
                  Before
                </div>
              </div>
              <div className="relative" data-id="element-246">
                <img src="https://cdn.magicpatterns.com/uploads/vzBEi6rojirjPEtvLL2MEv/pipesvcafter.jpg" alt="Manhole after rehabilitation" className="w-full h-full object-cover" data-id="element-247" />
                <div className="absolute bottom-0 left-0 right-0 bg-[#d4a017] text-[#1e3a5f] text-center py-2 font-bold uppercase tracking-wider text-sm" data-id="element-248">
                  After
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const PartnersCarousel = () => {
  const partners = [{
    name: 'CUES',
    logo: 'https://cdn.magicpatterns.com/uploads/wNdbJbJUA819KtS1bD1EiV/logo-cue.png'
  }, {
    name: 'FerraTex Solutions',
    logo: 'https://cdn.magicpatterns.com/uploads/9nzMmURpvoQyQzG4wYPmPc/Screenshot_2026-02-02_at_4.50.38_PM.png'
  }, {
    name: 'Nozzteq - A Division of Enz',
    logo: 'https://cdn.magicpatterns.com/uploads/jmfdCUy3pkfotycRrRjuse/660f0f7387eef0923df1a698_NozzTeq_Logo_High_res_1920x1080_transparent_1.png'
  }, {
    name: 'Pittsburgh Wire & Cable Inc.',
    logo: 'https://cdn.magicpatterns.com/uploads/ogxkVTotoXV8v2PS1JQQp6/pittsburgh_wire_cable_inc_logo.jpg'
  }, {
    name: 'Vactor',
    logo: 'https://cdn.magicpatterns.com/uploads/kKUcN6DD2K1rVjSdET6Unc/Vactor-logo.jpg'
  }, {
    name: 'Puris',
    logo: 'https://cdn.magicpatterns.com/uploads/r6KmtQzDwW6XmWWFGWiuQh/Puris_Logo_CLR.jpg'
  }];
  // Double the array for seamless infinite scroll
  const doubledPartners = [...partners, ...partners];
  return <section className="py-16 bg-white overflow-hidden" data-id="element-249">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10" data-id="element-250">
        <div className="text-center" data-id="element-251">
          <h2 className="text-3xl font-bold text-[#1e3a5f] mb-3" data-id="element-252">
            Our Trusted Partners
          </h2>
          <div className="w-16 h-1 bg-[#d4a017] mx-auto mb-4" data-id="element-253"></div>
          <p className="text-gray-600" data-id="element-254">
            We work with industry-leading equipment and material suppliers
          </p>
        </div>
      </div>

      {/* Carousel Container */}
      <div className="relative" data-id="element-255">
        {/* Gradient Overlays for fade effect */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-256"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-257"></div>

        {/* Scrolling Track */}
        <div className="flex animate-scroll" data-id="element-258">
          {doubledPartners.map((partner, index) => <div key={`${partner.name}-${index}`} className="flex-shrink-0 mx-8 md:mx-12 flex items-center justify-center" data-id="element-259">
              <img src={partner.logo} alt={partner.name} className="h-12 md:h-16 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-260" />
            </div>)}
        </div>
      </div>
    </section>;
};
export const HomePage = () => {
  return <>
      <Hero data-id="element-261" />
      <EmergencyBanner data-id="element-262" />
      <CertificationsSection data-id="element-263" />
      <ServicesSection data-id="element-264" />
      <PartnersCarousel data-id="element-265" />
    </>;
};